import { CardTheme } from '../types';
import { colors } from '../constants/colors';
import { typography } from '@zopauk/react-components';

export const card: CardTheme = {
  info: {
    borderStyle: `1px solid ${colors.jlMoneyGreenNeon}`,
    backgroundStyle: `${colors.jlMoneyGreenNeon}`,
    headingSize: typography.sizes.heading.h4,
    textSize: typography.sizes.text.small,
    boxShadowStyle: 'none',
    headingWeight: '500',
    borderRadius: '8px',
  },
  secondary: {
    boxShadowStyle: `0 1px 0 0 ${colors.greyLight}`,
    borderStyle: `1px solid ${colors.greyLighter}`,
    headingSize: typography.sizes.heading.h6,
    textSize: typography.sizes.text.small,
    backgroundStyle: `${colors.white};`,
    borderRadius: '0',
  },
  primary: {
    boxShadowStyle: `0 1px 0 0 ${colors.greyLight}`,
    borderStyle: `1px solid ${colors.greyLighter}`,
    headingSize: typography.sizes.heading.h5,
    textSize: typography.sizes.text.body,
    backgroundStyle: `${colors.white};`,
    borderRadius: '0',
  },
  action: {
    borderStyle: `1px solid ${colors.greyLighter}`,
    headingSize: typography.sizes.heading.h6,
    textSize: typography.sizes.text.small,
    backgroundStyle: `${colors.white};`,
    boxShadowStyle: 'none',
    borderRadius: '0',
  },
  brand: {
    borderStyle: `1px solid ${colors.jlBlack}`,
    headingSize: typography.sizes.heading.h6,
    textSize: typography.sizes.text.small,
    backgroundStyle: `${colors.white};`,
    boxShadowStyle: 'none',
    borderRadius: '0',
  },
};
